import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state type
interface ColorState {
    color: string;
}

// Initial state
const initialState: ColorState = {
    color: '#ff0000', 
};

// Redux slice
const colorSlice = createSlice({
    name: 'color',
    initialState,
    reducers: {
        setColor: (state, action: PayloadAction<string>) => {
            state.color = action.payload; 
        },
        resetColor: (state) => {
            state.color = initialState.color; 
        },
    },
});

// Export actions
export const { setColor, resetColor } = colorSlice.actions;

// Export reducer
export default colorSlice.reducer;

// Selector to get the current color
export const selectColor = (state: { color: ColorState }) => state.color.color;
